<!-- lsy -->
<template>
  <div id="gas-container">
    <!--主页面 -->
    <div class="flex-row"
         style="height: 100%">
      <div class="section-mian_left">{{ titleName }}</div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <!-- 控制器 -->
        <div v-if="devShow"
             class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar flex-row">
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-iconfontfanhui"
                       @click="retBtn">返回</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-plus"
                       v-auth="'/deviceaccess/index:addDevice'"
                       @click="handleAdd">新增</el-button>

            <el-upload ref="upload"
                       class="upload-demo"
                       multiple
                       :limit="1"
                       :auto-upload="false"
                       :on-change="batchImport"
                       action
                       :show-file-list="false">
              <el-button type="primary"
                         v-auth="'/deviceaccess/index:importDevice'"
                         class="iss-operation-button"
                         icon="iconfont icon-daoru">导入</el-button>
            </el-upload>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-download"
                       @click="downTemplate">模板下载</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-delete"
                       v-auth="'/deviceaccess/index:deleteDevice'"
                       @click="delDev">批量删除</el-button>
          </div>
          <div class="section-main_table">
            <ioc-table ref="devTab"
                       :data="gasDeviceData"
                       :option="deviceOption"
                       :page="devicePage"
                       @search-change="handleSearchChange"
                       @search-reset="resetForm"
                       @row-save="handleCreate"
                       @row-update="handleUpdate"
                       @current-change="selectPage"
                       @selection-change="selectionChange"
                       @size-change="changeSize">
              <!-- 定制操作栏按钮 -->
              <template slot="menu"
                        slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            content="探测器管理"
                            v-auth="'/deviceaccess/index:query'"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             @click="seeCamera(scope.row)"
                             icon="iconfont icon-Detail"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="修改"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             v-auth="'/deviceaccess/index:updateDevice'"
                             @click="update(scope.row)"
                             icon="iconfont icon-xiugai"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="详情"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             class="iconfont icon-Detail"
                             @click="showDetail(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="删除"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             v-auth="'/deviceaccess/index:deleteDevice'"
                             @click="delDevBtn(scope.row)"
                             icon="iconfont icon-shanchu"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
        <!-- 探测器 -->
        <div v-else
             class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar">
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-iconfontfanhui"
                       @click="backNvr">{{ $t("deviceAccess.button.back") }}</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-plus"
                       v-auth="'/deviceaccess/index:addDevice'"
                       @click="handleAdd">新增</el-button>
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table ref="partTab"
                       :data="cameraData"
                       :option="cameraOption"
                       :page="cameraPage"
                       @row-save="handlePartCreate"
                       @row-update="handlePartUpdate"
                       @search-change="handleSearchChange"
                       @search-reset="resetForm"
                       @current-change="selectPage"
                       @selection-change="selectionChange"
                       @size-change="changeSize">
              <!-- 定制操作栏按钮 -->
              <template slot="menu"
                        slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            content="修改"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             v-auth="'/deviceaccess/index:updateDevice'"
                             @click="update(scope.row)"
                             icon="iconfont icon-xiugai"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="详情"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             class="iconfont icon-Detail"
                             @click="showDetail(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('deviceAccess.button.delete')"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             @click="delDevBtn(scope.row)"
                             v-auth="'/deviceaccess/index:deleteDevice'"
                             icon="iconfont icon-shanchu"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="type == 'add' ? '新增' : '修改'"
               :visible="showEdit"
               v-dialogDrag
               width="50%"
               @close="cancel">
      <el-form ref="gasform"
               :model="addForm"
               v-if="devShow"
               :rules="addRules"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="通信ID"
                          prop="thirdDeviceId">
              <el-input :disabled="type == 'edit' ? true : false"
                        v-model="addForm.thirdDeviceId"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称"
                          prop="deviceName">
              <el-input v-model="addForm.deviceName"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制造厂"
                          prop="manufacturer">
              <el-input v-model="addForm.deviceExtendInfoMap.manufacturer"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号"
                          prop="deviceVersion">
              <el-input v-model="addForm.deviceVersion"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="介质属性"
                          prop="typeMark">
              <el-select v-model="addForm.typeMark"
                         style="width: 100%"
                         placeholder="请选择">
                <el-option v-for="val in typeList"
                           :value="val.value"
                           :label="val.label"
                           :key="val.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="IP地址"
                          prop="deviceHost">
              <el-input v-model="addForm.deviceHost"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"
                          prop="thirdDeviceDesc">
              <el-input type="textarea"
                        v-model="addForm.thirdDeviceDesc"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form ref="gasPartForm"
               :model="partForm"
               v-else
               :rules="partRules"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="数据地址"
                          prop="deviceId">
              <el-input v-model="partForm.deviceId"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称"
                          prop="thirdDeviceName">
              <el-input v-model="partForm.thirdDeviceName"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="测量介质"
                          prop="measureMedium">
              <el-input v-model="partForm.deviceExtendInfoMap.measureMedium"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="介质属性"
                          prop="typeMark">
              <el-select v-model="partForm.typeMark"
                         style="width: 100%"
                         @change="typeMarkChange"
                         placeholder="请选择">
                <el-option v-for="val in typeList"
                           :value="val.value"
                           :label="val.label"
                           :key="val.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="低阈值"
                          prop="lowThreshold">
              <el-input v-model="partForm.deviceExtendInfoMap.lowThreshold"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="高阈值"
                          prop="highThreshold">
              <el-input v-model="partForm.deviceExtendInfoMap.highThreshold"
                        placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="cancel"> 取消</el-button>
        <el-button type="primary"
                   @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableOption from "../config/gasConfigTable.js";
import partOption from "../config/gasTruckTable.js";
import utils from "@src/common/utils";
import { api } from "../api/index";
import { Dic } from "$utils";
import deviceMap from "@src/modules/cameraList/components/deviceMap";
export default {
  data () {
    return {
      showEdit: false,
      addRules: {
        thirdDeviceId: [{ required: true, message: "请输入", trigger: "blur" }],
        deviceName: [{ required: true, message: "请输入", trigger: "blur" }],
        deviceVersion: [{ required: true, message: "请输入", trigger: "blur" }],
        typeMark: [{ required: true, message: "请选择", trigger: "change" }],
        deviceHost: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      partRules: {
        deviceId: [{ required: true, message: "请输入", trigger: "blur" }],
        thirdDeviceName: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        typeMark: [{ required: true, message: "请选择", trigger: "change" }],
      },
      gasDeviceData: [
        {
          communicationId: "132312",
          measurePointAddr: "测试",
          longitude: "32.333",
        },
      ],
      typeList: Dic.find("SENU110"),
      deviceOption: tableOption(this),
      cameraOption: partOption(this),
      devShow: true,
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      cameraPage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceTreeShow: false,
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      devInOption: tableOption(this),
      addForm: {
        deviceExtendInfoMap: {
          manufacturer: "",
        },
      },
      //部件form
      partForm: {
        typeMark: "",
        thirdDeviceId: "",
        deviceID: "",
        deviceExtendInfoMap: {
          lowThreshold: "",
          highThreshold: "",
          measureMedium: "",
        },
      },
      parentDeviceId: "",
      parentThirdDeviceId: "",
      factoryId: "",
      cameraQueryForm: {},
      selDev: [],
      delConfirm: false,
      type: "",
      titleName: "",
      deviceID: "",
      cameraData: [],
      downFileName: "importGasTemplate",
      //isShow: false,
    };
  },
  mixins: [deviceMap],
  components: {},
  watch: {
    vH () {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    showBuilding (newVal, oldVal) {
      if (oldVal) {
        this.clearCanvas();
      }
    },
    devShow (newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.requestList();
        });
      }
    },
  },
  mounted () {
    this.titleName = this.$route.query.systemName;
    this.requestList();
  },
  methods: {
    // 类型选中回调
    typeMarkChange (val) {
      this.partForm.deviceExtendInfoMap.lowThreshold = val == 1 ? 25 : 19.5;
      this.partForm.deviceExtendInfoMap.highThreshold = val == 1 ? 50 : 23.5;
    },
    requestList (data) {
      let form = {
        deviceMarkList: ["33"],
        systemId: "200000013",
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
      };
      let params = Object.assign(form, data);
      this.$fetch("cms/accessportal/queryFireDevice.json", params).then(
        (res) => {
          if (res.success) {
            this.gasDeviceData = res.returnObj.list;
            this.devicePage.total = res.returnObj.total;
          }
        }
      );
    },
    //新增/修改确认
    submit () {
      if (this.devShow) {
        if (this.type == "add") {
          this.handleCreate(this.addForm);
        } else {
          this.handleUpdate(this.addForm);
        }
      } else {
        if (this.type == "add") {
          this.handlePartCreate(this.partForm);
        } else {
          this.handlePartUpdate(this.partForm);
        }
      }
    },
    //取消
    cancel () {
      if (this.devShow) {
        console.log(1);
        this.$refs["gasform"].resetFields();
        this.addForm.deviceExtendInfoMap.manufacturer = "";
      } else {
        console.log(2);
        this.$refs["gasPartForm"].resetFields();
        this.partForm.deviceExtendInfoMap.measureMedium = "";
        this.partForm.deviceExtendInfoMap.lowThreshold = "";
        this.partForm.deviceExtendInfoMap.highThreshold = "";
      }
      this.$nextTick(() => {
        this.showEdit = false;
      });
    },
    //重置
    clearSearch () {
      this.searchString = "";
      this.filterText();
    },
    delDev () {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.deletePlatDevice();
      });
    },
    // 确认删除
    deletePlatDevice (row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      this.$fetch(api.device.deleteFireDevice, params).then((res) => {
        if (res.success) {
          this.requestList();
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.devTab.selectClear();
      });
    },
    // 返回按钮
    retBtn () {
      this.$router.go(-1);
    },
    //部件返回
    backNvr () {
      this.devShow = true;
      this.cameraQueryForm = {
        parentDeviceId: "",
        mac: "",
        deviceName: "",
      };
    },
    //新增
    handleAdd () {
      this.type = "add";
      this.showEdit = true;
      // if (this.devShow) {
      //   this.$refs["gasform"].resetFields();
      //   console.log(this.addForm)
      //   // this.addForm = {
      //   //   deviceExtendInfoMap: {
      //   //     manufacturer: "",
      //   //   },
      //   // };
      // } else {
      //   this.partForm = {
      //     thirdDeviceId: "",
      //     deviceExtendInfoMap: {
      //       lowThreshold: "18.5",
      //       highThreshold: "29.5",
      //       measureMedium: "",
      //     },
      //   };
      // }
    },
    //模板下载
    downTemplate () {
      this.$fetchGet(api.gasTruck.getTemplateFile, {
        responseType: "blob", //设置返回类型
      }).then((res) => {
        if (typeof window.chrome !== "undefined") {
          // Chrome version
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const url = window.URL || window.webkitURL || window.moxURL;
          const urls = url.createObjectURL(blob);
          const a = document.createElement("a"); // 生成虚拟a标签
          a.href = urls;
          a.download = this.downFileName + ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          url.revokeObjectURL(urls); // 释放掉blob对象
        } else if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE version
          const blob = new Blob([res], { type: "application/force-download" });
          window.navigator.msSaveBlob(blob, this.downFileName + ".xlsx");
        } else {
          // Firefox version
          const file = new File([res], this.downFileName + ".xlsx", {
            type: "application/force-download",
          });
          window.open(URL.createObjectURL(file));
        }
      });
    },
    // 批量导入按钮
    batchImport (file) {
      if (
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xlsx" &&
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        // 调用导入接口
        this.$fetch(api.gasTruck.importGasDevice, formData).then((response) => {
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.requestList();
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode (node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    //删除
    delDevBtn (row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.deletePlatDevice(row);
      });
    },
    showDetail (row) {
      if (this.devShow) {
        this.$refs.devTab.rowView(row);
      } else {
        this.$refs.partTab.rowView(row);
      }
    },
    handleSearchChange (data) {
      if (this.devShow) {
        this.requestList(data);
      } else {
        this.requestCameraList(data);
      }
    },
    resetForm () {
      if (this.devShow) {
        this.requestList();
      } else {
        this.requestCameraList();
      }
    },
    handleCreate (addInfo) {
      this.$refs["gasform"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          addInfo.deviceExtendInfoMap.manufacturer
            ? ""
            : delete addInfo.deviceExtendInfoMap.manufacturer;
          let form = {
            parentDeviceId: "200000013",
            parentDeviceIds: "200000013",
            systemId: 200000013,
            factoryId: addInfo.factoryId,
            deviceVersion: addInfo.deviceVersion,
            thirdDeviceName: addInfo.deviceName,
            thirdDeviceDesc: addInfo.thirdDeviceDesc,
            thirdDeviceId: addInfo.thirdDeviceId,
            deviceType: "22",
            deviceMark: "33",
            typeMark: addInfo.typeMark,
            ip: addInfo.deviceHost,
            deviceExtendInfoMap: addInfo.deviceExtendInfoMap,
          };

          this.$fetch(api.gasTruck.addDevice, form).then((res) => {
            if (res && res.success) {
              this.requestList();
              this.showEdit = false;
              // done();
              this.$message.success("新增成功");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    handleUpdate (editInfo) {
      this.$refs["gasform"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          editInfo.deviceExtendInfoMap.manufacturer
            ? ""
            : delete editInfo.deviceExtendInfoMap.manufacturer;
          let form = {
            parentDeviceId: "200000013",
            parentDeviceIds: "200000013",
            systemId: 200000013,
            factoryId: editInfo.factoryId,
            deviceVersion: editInfo.deviceVersion,
            thirdDeviceName: editInfo.deviceName,
            thirdDeviceDesc: editInfo.thirdDeviceDesc,
            thirdDeviceId: editInfo.thirdDeviceId,
            deviceType: "22",
            deviceMark: "33",
            deviceID: this.deviceID,
            typeMark: editInfo.typeMark,
            ip: editInfo.deviceHost,
            deviceExtendInfoMap: editInfo.deviceExtendInfoMap,
          };
          this.$fetch(api.gasTruck.updateDevice, form).then((res) => {
            if (res && res.success) {
              this.requestList();
              this.showEdit = false;
              this.$message.success("修改成功");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    handlePartCreate (addInfo, done) {
      this.$refs["gasPartForm"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let ids = [];
          ids.push(200000013, this.parentDeviceId);
          let form = {
            factoryId: this.factoryId,
            parentDeviceIds: ids.join(","),
            systemId: "200000013",
            //   thirdDeviceId: this.parentThirdDeviceId,
            parentDeviceId: this.parentDeviceId,
            deviceMark: "34",
            deviceType: "22",
          };
          addInfo.deviceExtendInfoMap.measureMedium
            ? ""
            : delete addInfo.deviceExtendInfoMap.measureMedium;
          addInfo.deviceExtendInfoMap.lowThreshold
            ? ""
            : delete addInfo.deviceExtendInfoMap.lowThreshold;
          addInfo.deviceExtendInfoMap.highThreshold
            ? ""
            : delete addInfo.deviceExtendInfoMap.highThreshold;
          const params = Object.assign(addInfo, form);
          params.thirdDeviceId =
            this.parentThirdDeviceId + "-" + addInfo.deviceId;
          this.$fetch(api.gasTruck.addDevice, params).then((res) => {
            if (res && res.success) {
              this.showEdit = false;
              this.requestCameraList();
              this.$message.success("新增成功");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    handlePartUpdate (updateInfo, done) {
      this.$refs["gasPartForm"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let ids = [];
          ids.push(200000013, this.parentDeviceId);
          updateInfo.deviceExtendInfoMap.measureMedium
            ? ""
            : delete updateInfo.deviceExtendInfoMap.measureMedium;
          updateInfo.deviceExtendInfoMap.lowThreshold
            ? ""
            : delete updateInfo.deviceExtendInfoMap.lowThreshold;
          updateInfo.deviceExtendInfoMap.highThreshold
            ? ""
            : delete updateInfo.deviceExtendInfoMap.highThreshold;
          let params = {
            deviceID: updateInfo.deviceID,
            thirdDeviceId: updateInfo.thirdDeviceId,
            deviceMark: "34",
            deviceType: "22",
            systemId: "200000013",
            thirdDeviceName: updateInfo.thirdDeviceName,
            typeMark: updateInfo.typeMark,
            deviceExtendInfoMap: updateInfo.deviceExtendInfoMap,
          };
          this.$fetch(api.gasTruck.updateDevice, params).then((res) => {
            if (res && res.success) {
              this.requestCameraList();
              this.showEdit = false;
              this.$message.success("修改成功");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    // 点击上一页下一页按钮
    selectPage (val) {
      if (this.devShow) {
        this.devicePage.currentPage = val;
        this.requestList();
      } else {
        this.cameraPage.currentPage = val;
        this.requestCameraList();
      }
    },
    // 当选择项发生变化时会触发该事件
    selectionChange (selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 修改每页数据数量
    changeSize (val) {
      if (this.devShow) {
        this.devicePage.currentPage = 1;
        this.devicePage.pageSize = val;
        this.requestList();
      } else {
        this.cameraPage.currentPage = 1;
        this.cameraPage.pageSize = val;
        this.requestCameraList();
      }
    },
    //查看部件列表
    seeCamera (row) {
      this.parentDeviceId = row.deviceID;
      this.parentThirdDeviceId = row.thirdDeviceId;
      this.factoryId = row.factoryId;
      this.devShow = false;
      this.requestCameraList();
    },
    //查询部件列表
    // 请求数据列表数据
    requestCameraList (data) {
      const form = {
        pageSize: this.cameraPage.pageSize,
        pageNum: this.cameraPage.currentPage,
        deviceMark: "34",
        deviceType: "22",
        systemId: "200000013",
        parentDeviceId: this.parentDeviceId,
      };
      let params = Object.assign(form, data);
      this.$fetch(api.device.queryFireSubDevice, params).then((res) => {
        if (res.success && res.returnObj.list) {
          this.cameraData = res.returnObj.list;
          this.cameraPage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    update (row) {
      this.type = "edit";
      this.showEdit = true;
      this.$nextTick(() => {
        if (this.devShow) {
          this.addForm = JSON.parse(JSON.stringify(row));
          this.addForm.typeMark = Number(this.addForm.typeMark);
          this.deviceID = row.deviceID;
        } else {
          this.partForm = JSON.parse(JSON.stringify(row));
          let index = row.thirdDeviceId.indexOf("-");
          this.partForm.deviceId = row.thirdDeviceId.slice(index + 1);
          this.partForm.typeMark = Number(this.partForm.subTypeMark);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
#gas-container {
  height: 100%;
}
.section-mian_left {
  text-align: center;
}
.el-table .cell.el-tooltip {
  white-space: break-spaces;
}
.nvr-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.section-main_table {
  // height: calc( 100% - 500px);
}
.tree-container {
  height: 450px;
}
.scroll-bar-view {
  height: 90%;
}
.iss-operation-button {
  margin-left: 10px;
}
.map-choose {
  position: absolute;
  right: -5px;
  top: 0px;
}
#map-container {
  height: 450px;
}
.right-img {
  margin-top: 35px;
  margin-left: 10px;
  flex: 2;

  #building-img {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.canvasMain {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .canvasMainT {
    position: absolute;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
    }
    canvas {
      position: absolute;
    }
  }
}
.flex-container {
  display: flex;
  margin-bottom: 10px;
  .left-tree {
    // width: 45%;
    // float: left;
    // display: inline;
    flex: 1;
    height: 500px;
  }
  .right-img {
    margin-top: 35px;
    margin-left: 10px;
    flex: 2;

    #building-img {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>